import { func, shape, string } from 'prop-types';
import React from 'react';

import {
  PROJECT_QUOTE_VIEW_ERROR,
  PROJECT_VIEW,
  QUOTE_VIEW,
} from '../constants';
import ErrorComponent from '../generic/Error';
import Loading from '../generic/Loading';
import Titled from '../layout/Titled';
import { ProjectEntityPropTypes } from '../project/ProjectEntity/ProjectEntity';
import api from '../REST/api';

function withQuoteData(WrappedComponent) {
  class WithQuoteData extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        opportunity: null,
        quote: null,
        products: null,
        view: '',
        error: null,
      };
    }

    componentDidMount() {
      if (this.props.opportunityId) {
        const opportunityRequest = api.getOpportunity({
          id: this.props.opportunityId,
        });
        const quoteRequest = opportunityRequest.then(({ primaryQuote }) =>
          api.getQuote({ id: primaryQuote?.id }),
        );
        const productRequest = api.getProducts();
        this.resolvePromises(
          opportunityRequest,
          quoteRequest,
          productRequest,
          PROJECT_VIEW,
        );
      } else {
        const productRequest = api.getProducts();
        const quoteRequest = api.getQuote({ id: this.props.match.params.id });
        const opportunityRequest = quoteRequest.then(({ opportunityId }) =>
          api.getOpportunity({ id: opportunityId }),
        );
        this.resolvePromises(
          opportunityRequest,
          quoteRequest,
          productRequest,
          QUOTE_VIEW,
        );
      }
    }

    resolvePromises = (
      opportunityRequest,
      quoteRequest,
      productsRequest,
      view,
    ) => {
      Promise.all([quoteRequest, opportunityRequest, productsRequest]).then(
        ([quote, opportunity, products]) => {
          this.setState({
            opportunity,
            quote,
            products,
            view,
          });
        },
        error => this.setState({ error, view }),
      );
    };

    render() {
      const { opportunity, quote, products, error, view } = this.state;

      if (opportunity && quote && products) {
        return (
          <WrappedComponent
            opportunity={opportunity}
            quote={quote}
            products={products}
            view={view}
            {...this.props}
          />
        );
      }

      return (
        <Titled title="Quote" size="sm">
          {error ? (
            <ErrorComponent
              error={
                view === PROJECT_VIEW
                  ? { message: PROJECT_QUOTE_VIEW_ERROR }
                  : error
              }
            />
          ) : (
            <Loading />
          )}
        </Titled>
      );
    }
  }

  WithQuoteData.propTypes = {
    opportunityId: string,
    entityProps: shape(ProjectEntityPropTypes),
    match: shape({ params: shape({ id: string }) }),
    location: shape({ search: string }),
    history: shape({ push: func }),
  };

  WithQuoteData.defaultProps = {
    opportunityId: null,
    match: { params: { id: null } },
    entityProps: {
      onSave: () => {},
      onCancel: () => {},
      onEdit: () => {},
      onExpansionToggle: () => {},
      isEditable: false,
      isEditing: false,
      isExpanded: false,
      isExpandable: false,
    },
    location: {},
    history: {},
  };

  return WithQuoteData;
}

export default withQuoteData;
